import Vue from 'vue'
import Vuex from 'vuex'
import storage from './modules/storage'
import account from './modules/account'
import healthDocUser from './modules/healthDocUser'
import mHealthInfo from './modules/m-healthInfo'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    storage, account, healthDocUser, mHealthInfo
  }
})
